import { useInterestSectionLoader } from 'containers/redesignStudent/dataEntityContainers/profile/interests';
import {
  getCivilLoaderConfig,
  getCreationLoaderConfig,
  getCultureLoaderConfig,
  getProfessionLoaderConfig,
  getScienceLoaderConfig,
  getSportLoaderConfig,
  getStudyLoaderConfig,
  useSectionLoader,
} from 'portfolio3/containers/sections/loader';
import { useDiagnosticsWidgetLoader } from 'portfolio3/features/diagnostics';

const SectionsDataLoader = () => {
  const studyLoaderConfig = getStudyLoaderConfig(false);
  const scienceLoaderConfig = getScienceLoaderConfig();
  const sportLoaderConfig = getSportLoaderConfig();
  const creationLoaderConfig = getCreationLoaderConfig();
  const cultureLoaderConfig = getCultureLoaderConfig();
  const civilLoaderConfig = getCivilLoaderConfig();
  const professionLoaderConfig = getProfessionLoaderConfig();
  useSectionLoader(studyLoaderConfig);
  // Данные по диагностикам подргужаются отдельно
  useDiagnosticsWidgetLoader();
  useSectionLoader(scienceLoaderConfig);
  useSectionLoader(sportLoaderConfig);
  useSectionLoader(creationLoaderConfig);
  useSectionLoader(cultureLoaderConfig);
  useSectionLoader(civilLoaderConfig);
  useSectionLoader(professionLoaderConfig);

  // Подрузка данных Анкеты интересов
  useInterestSectionLoader();

  return null;
};

export default SectionsDataLoader;
